// Oliver Sweeney — Product page
// Depends on: os-cart.js, os-global.js, swiper-bundle.min.js


// ─── Variants ─────────────────────────────────────────────────────────────────
class Variants {
  constructor(elem) {
    this._elem     = elem
    this._variants = elem.querySelectorAll('[data-variant]')
    this._input    = document.querySelector('input[name="id"]')
  }
  onInit() {
    this._elem.addEventListener('click', e => {
      const v = e.target.closest('[data-variant]')
      if (v) this._update(v.getAttribute('data-variant'))
    })
    this._elem.addEventListener('change', () => this._update(this._elem.value))
  }
  async _update(id) {
    if (this._input) this._input.value = id
    this._updateUrl(id)
    const response = await fetch(`${window.location.pathname}?variant=${id}`)
    const html     = await response.text()
    const doc      = document.createElement('div')
    doc.innerHTML  = html
    const grab = sel => doc.querySelector(sel)
    const set  = (sel, inner) => { const el = document.querySelector(sel); if (el && inner !== null) el.innerHTML = inner }
    set('.product__variants', grab('.product__variants')?.innerHTML ?? null)
    set('.product-price',     grab('.product-price')?.innerHTML     ?? null)
    set('.product__wishlist', grab('.product__wishlist')?.innerHTML  ?? null)
    const cta = grab('.product__cta')
    if (cta) {
      const ctaEl = document.querySelector('.product__cta')
      ctaEl?.setAttribute('data-add-to-cart', cta.getAttribute('data-add-to-cart'))
      if (ctaEl) { ctaEl.innerHTML = cta.innerHTML; ctaEl.disabled = cta.disabled }
    }
    document.querySelectorAll('form.product-form').forEach(form => window.initComponents?.(form))
  }
  _updateUrl(id) {
    const url = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${id}`
    window.history.replaceState({ path: url }, '', url)
  }
}

// ─── Product page ─────────────────────────────────────────────────────────────
class ProductPage {
  static _openPopup(id) {
    const el = document.getElementById(id)
    if (el) { el.style.opacity = 1; el.style.visibility = 'visible' }
  }
  static _closePopups() {
    document.querySelectorAll('.popup').forEach(el => {
      el.style.opacity = 0; el.style.visibility = 'hidden'
    })
  }
  constructor() {
    this._addToCartBtns = document.querySelectorAll('[data-add-to-cart]')
    this._popupOverlays = document.querySelectorAll('.popup__overlay')
    this._popupCloses   = document.querySelectorAll('.popup__close')
    this._sizeguide     = document.querySelector('.popupSizeguide')
    this._mainSlider    = document.querySelector('[data-main-slider]')
    this._thumbSlider   = document.querySelector('[data-thumbnail-slider]')
  }
  onInit() {
    this._bindPopups()
    this._bindAddToCart()
    this._initSliders()
    this._initProductVideos()
    if (document.querySelector('.gallery')) productGallery()
  }
  _bindPopups() {
    this._sizeguide?.addEventListener('click', e => { e.preventDefault(); ProductPage._openPopup('popupSizeguide') })
    this._popupOverlays.forEach(el => el.addEventListener('click', e => { e.preventDefault(); ProductPage._closePopups() }))
    this._popupCloses.forEach(el   => el.addEventListener('click', e => { e.preventDefault(); ProductPage._closePopups() }))
  }
  _bindAddToCart() {
    this._addToCartBtns.forEach(btn => {
      btn.addEventListener('click', async e => {
        e.preventDefault()
        const info = JSON.parse(btn.getAttribute('data-add-to-cart'))
        const originalText = btn.textContent
        btn.textContent = info.adding
        await window.OSCart.addItem({ quantity: 1, id: info.id })
        btn.textContent = info.added
        ProductPage._openPopup('popupAddtoBag')
        setTimeout(() => { btn.textContent = originalText }, 3000)
      })
    })
  }
  _initSliders() {
    if (!window.Swiper || !this._mainSlider || !this._thumbSlider) return
    const thumbnails = new window.Swiper(this._thumbSlider, {
      slidesPerView: 7, spaceBetween: 10, watchSlidesProgress: true
    })
    const mainSlider = new window.Swiper(this._mainSlider, {
      watchSlidesProgress: true,
      pagination: { el: '.swiper-pagination' },
      thumbs: { swiper: thumbnails },
      preventClicks: true,
      preventClicksPropagation: true
    })
    mainSlider.on('slideChange', () => {
      document.querySelectorAll('.product__media-slider video').forEach(vid => {
        if (!vid.paused) vid.dispatchEvent(new Event('pauseVideo'))
      })
    })
  }
  _initProductVideos() {
    document.querySelectorAll('.productVideo').forEach(vid => {
      const playBtn = document.getElementById(`${vid.id}play`)
      vid.addEventListener('click', () => {
        if (vid.paused || vid.ended) {
          vid.play()
          if (playBtn) playBtn.style.display = 'none'
        } else {
          vid.pause()
          if (playBtn) playBtn.style.display = 'block'
        }
      })
    })
  }
}

// ─── Product gallery (custom carousel + zoom) ─────────────────────────────────
function productGallery() {
  const items      = document.getElementsByClassName('gallery__photo')
  const totalItems = items.length
  if (!totalItems) return
  const gallery    = document.getElementsByClassName('gallery')[0]
  let slide        = 0
  let moving       = true
  let touchstartX  = 0
  let touchstartY  = 0
  const widthAdjust = screen.width >= 769 ? (gallery.dataset.width - 1) : 0

  let _lastWidth = window.innerWidth
  window.onresize = () => {
    const w = window.innerWidth
    if (w === _lastWidth) return  // height-only resize (mobile address bar hide/show)
    _lastWidth = w
    if (w <= 768 && document.getElementsByClassName('gallery__photo active')[1]) {
      document.getElementsByClassName('gallery__photo active')[1].classList.remove('active')
    } else if (w > 768) {
      items[widthAdjust]?.classList.add('active')
    }
  }

  const disableInteraction = () => {
    moving = true
    setTimeout(() => {
      moving = false
      Array.from(items).forEach(el => el.classList.remove('transitioning'))
    }, 500)
  }

  function loadSlide(img) {
    if (!img || !img.dataset.src) return
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset
      delete img.dataset.srcset
    }
    img.src = img.dataset.src
    delete img.dataset.src
  }

  const moveTo = () => {
    const next = document.getElementsByClassName('gallery__button--next')[0]
    const prev = document.getElementsByClassName('gallery__button--prev')[0]
    if (moving) return
    disableInteraction()
    if ((widthAdjust + slide) >= totalItems) slide -= widthAdjust
    const newPrev = slide - 1
    let   newNext = newPrev + 2
    if (slide === 0) {
      if (prev) prev.style.display = 'none'
      if (next) next.style.display = 'block'
    } else if (slide + widthAdjust === totalItems - 1) {
      if (next) next.style.display = 'none'
      if (prev) prev.style.display = 'block'
      newNext = 0
    } else {
      if (next) next.style.display = 'block'
      if (prev) prev.style.display = 'block'
    }
    Array.from(items).forEach(el => { el.className = 'gallery__photo transitioning' })
    items[slide]?.classList.add('active')
    loadSlide(items[slide])
    items[newPrev]?.classList.add('prev')
    loadSlide(items[newPrev])
    if (slide + widthAdjust === totalItems - 1) {
      items[0]?.classList.add('next')
      loadSlide(items[0])
    } else {
      items[widthAdjust + newNext]?.classList.add('next')
      loadSlide(items[widthAdjust + newNext])
    }
    if (widthAdjust === 1 && screen.width >= 769) {
      const extra = items[slide + widthAdjust]
      if (extra) {
        extra.classList.add('active')
        loadSlide(extra)
        ImageZoom(extra)
        const actives = document.getElementsByClassName('gallery__photo active')
        actives[0]?.classList.add('left')
        actives[1]?.classList.add('right')
      }
    }
    if (screen.width >= 769) ImageZoom(items[slide])
  }

  const moveNext = () => {
    if (!moving && slide < totalItems - 1) {
      slide++
      Array.from(document.getElementsByClassName('gallery__photo')).forEach(el => el.classList.add('prev'))
      moveTo()
    }
  }
  const movePrev = () => {
    if (!moving && slide > 0) {
      slide--
      Array.from(document.getElementsByClassName('gallery__photo')).forEach(el => el.classList.add('next'))
      moveTo()
    }
  }

  document.getElementsByClassName('gallery__button--next')[0]?.addEventListener('click', moveNext)
  document.getElementsByClassName('gallery__button--prev')[0]?.addEventListener('click', movePrev)
  gallery.addEventListener('touchstart', e => {
    touchstartX = e.changedTouches[0].screenX
    touchstartY = e.changedTouches[0].screenY
  }, { passive: true })
  gallery.addEventListener('touchend', e => {
    if (e.touches.length > 0) return
    const dx = e.changedTouches[0].screenX - touchstartX
    const dy = e.changedTouches[0].screenY - touchstartY
    if (Math.abs(dx) < 30 || Math.abs(dx) <= Math.abs(dy)) return
    if (dx < 0) moveNext()
    if (dx > 0) movePrev()
  })
  Array.from(document.getElementsByClassName('gallery__thumb')).forEach(thumb => {
    thumb.addEventListener('click', e => { slide = parseInt(e.currentTarget.dataset.index); moveTo() })
  })
  function ImageZoom(image) {
    if (!image?.parentElement) return
    const container = image.parentElement
    let touchable = false
    let scaleX, scaleY, offset
    const options = { width: 0, height: 0 }

    container.style.position = 'relative'
    document.querySelectorAll('.product-zoom__zoomed-image, .product-zoom__zoomed-area').forEach(el => el.remove())

    const lens = document.createElement('div')
    lens.classList.add('product-zoom__zoomed-area')
    lens.style.display = 'none'
    container.appendChild(lens)

    const zoomed = document.createElement('div')
    zoomed.classList.add('product-zoom__zoomed-image')
    zoomed.style.cssText = `background-image:url(${image.dataset.zoom || image.src});display:none`
    container.appendChild(zoomed)

    let lensW = 0, lensH = 0

    const onLoad = () => {
      options.width  = image.width
      options.height = image.height
      scaleX = image.naturalWidth  / options.width
      scaleY = image.naturalHeight / options.height
      offset = image.getBoundingClientRect()
      zoomed.style.cssText += `;width:calc(100% - 2px);height:calc(100% - 2px);background-size:${image.naturalWidth}px ${image.naturalHeight}px;display:block`
      lensW = zoomed.clientWidth  / scaleX
      lensH = zoomed.clientHeight / scaleY
      zoomed.style.display = 'none'
      lens.style.cssText   += `;position:absolute;width:${lensW}px;height:${lensH}px;pointer-events:none`
    }

    container.addEventListener('mousemove', e => {
      if (touchable || !offset) return
      const lx = Math.max(lensW / 2, Math.min(e.clientX - offset.left, options.width  - lensW / 2)) - lensW / 2
      const ly = Math.max(lensH / 2, Math.min(e.clientY - offset.top,  options.height - lensH / 2)) - lensH / 2
      zoomed.style.backgroundPosition = `-${lx * scaleX}px -${ly * scaleY}px`
      lens.style.cssText += `;transform:translate(${lx}px,${ly}px);display:block;left:0;top:0`
    })
    container.addEventListener('mouseenter', () => {
      if (touchable) return
      offset = image.getBoundingClientRect()
      zoomed.style.display = 'block'
      lens.style.display   = 'block'
    })
    container.addEventListener('mouseleave', () => {
      zoomed.style.display = 'none'
      lens.style.display   = 'none'
    })
    window.addEventListener('scroll', () => { if (offset) offset = image.getBoundingClientRect() })
    document.addEventListener('touchstart', () => { touchable = true }, { once: true })

    if (image.complete) onLoad(); else image.onload = onLoad
  }

  items[widthAdjust]?.classList.add('active')
  items[1 + widthAdjust]?.classList.add('next')
  Array.from(document.getElementsByClassName('gallery__photo active')).forEach(loadSlide)
  loadSlide(items[1 + widthAdjust])
  if (screen.width >= 769) {
    Array.from(document.getElementsByClassName('gallery__photo active')).forEach(ImageZoom)
  }
  moving = false
}

// ─── Size persistence across colour variants ──────────────────────────────────
// Each colour is a separate Shopify product, so navigating between colours loses
// the selected size. We persist it in sessionStorage and re-apply on page load.
const _SIZE_KEY = 'os_selected_size'

function _getSizeLabel(el) {
  const ukSpan = el.querySelector('span.uk')
  if (ukSpan) return ukSpan.textContent.trim()
  const p = el.querySelector('p')
  return (p || el).textContent.trim()
}

// Delegated listener — fires even after Variants._update re-renders the buttons
document.addEventListener('click', e => {
  const btn = e.target.closest('.variant__options--size .variant__option')
  if (!btn || btn.classList.contains('disabled')) return
  const label = _getSizeLabel(btn)
  if (label) sessionStorage.setItem(_SIZE_KEY, label)
})

function _applySavedSize() {
  // If the URL has ?variant= the server already pre-selected a specific variant — don't override
  if (new URLSearchParams(window.location.search).has('variant')) return
  const stored = sessionStorage.getItem(_SIZE_KEY)
  if (!stored) return
  document.querySelectorAll('.variant__options--size .variant__option:not(.disabled)').forEach(el => {
    if (_getSizeLabel(el) === stored) el.click()
  })
}

// ─── Boot ─────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-variants]').forEach(el => {
    if (el._os_variants_init) return
    el._os_variants_init = true
    new Variants(el).onInit()
  })
  new ProductPage().onInit()
  _applySavedSize()
})
